'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('custom-view', {
      url: '/custom-view/:type',
      template: '<custom-view></custom-view>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/custom/view/custom-view.routes.js